<template>
  <div>
    <div class="col-mail col-mail-1">
      <div class="checkbox-wrapper-mail">
        <input type="checkbox" id="chk19" />
        <label for="chk19" class="toggle"></label>
      </div>
      <router-link :to="'/support/inbox/' + id" href="">
        <p class="title">{{ sender }}</p>
      </router-link>
    </div>
    <router-link :to="'/support/inbox/' + id" class="col-mail col-mail-2">
      <div class="subject">{{ message }}</div>
      <div class="date">{{ date | moment("d MMM.") }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'one-message',
  props: {
    id: Number,
    sender: String,
    message: String,
    date: Date
  }
};
</script>

<style scoped></style>
